import React from 'react';
import { useTranslation } from 'react-i18next';
import { SmallButton } from '../../../settings/ui/small-button.component';
import { ArrowLeft } from '../icons';

interface IProps {
  onClose: () => void;
  text: string;
  onClick?: () => void;
}

export const PopupButtons = ({ onClick, onClose, text }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-row justify-between mt-[10px] gap-[12px] md:gap-[22px]">
      <SmallButton text={t('common.back')} type="back" icon={<ArrowLeft />} onClick={onClose} />
      <SmallButton text={text} type="update" buttonType="submit" onClick={onClick} />
    </div>
  );
};
